module.exports = __webpack_public_path__ + "static/media/biomarker_gene.3afec85f.png";